import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '@/configuration/setup/store';

interface VehicleWarningsSidebarState {
    isOpen: boolean;
}

const initialState: VehicleWarningsSidebarState = {
    isOpen: false,
};

const vehicleWarningsSidebarSlice = createSlice({
    name: 'vehicleWarningsSidebar',
    initialState,
    reducers: {
        openVehicleWarningsSidebar: (state) => {
            state.isOpen = true;
        },
        closeVehicleWarningsSidebar: (state) => {
            state.isOpen = false;
        },
    },
});

// Actions
export const { openVehicleWarningsSidebar, closeVehicleWarningsSidebar } = vehicleWarningsSidebarSlice.actions;

// Selectors
export const getVehicleWarningsSidebarIsOpen = (state: RootState) => state.vehicleWarningsSidebar.isOpen;

export default vehicleWarningsSidebarSlice.reducer;
